<template>
	<el-container class="friend-page">
		<resizable-aside :default-width="260" :min-width="200" :max-width="500" storage-key="friend-aside-width">
			<div class="header">
				<el-input class="search-text" size="small" :placeholder="$t('common.search')" v-model="searchText">
					<i class="el-icon-search el-input__icon" slot="prefix"> </i>
				</el-input>
				<el-button plain class="add-btn" icon="el-icon-plus" :title="$t('friend.addFriend')"
					@click="onShowAddFriend()"></el-button>
				<add-friend :dialogVisible="showAddFriend" @close="onCloseAddFriend"></add-friend>
			</div>
			<virtual-scroller v-if="useVirtual" class="friend-items" :items="friendItems" :key="virtualFriendListKey">
				<template #top>
					<div class="scrollbar-content">
						<div v-if="enableForceAdd" class="batch-add" @click="onShowBatchForceImport">
							<i class="el-icon-circle-plus-outline"></i>
							<span>批量强加</span>
						</div>
						<!-- 顶部列表: 新的朋友、ai机器人等 -->
						<div class="top-item" :class="showFriendReuqest ? 'active' : ''" @click="onClickNewFriend">
							<div class="top-item-avatar">
								<head-image :size="42" :url="require('@/assets/image/new_friend.png')">
									<div v-show="recvCount" class="unread-text">{{ recvCount }} </div>
								</head-image>
							</div>
							<div class="top-item-info">
								<div class="top-item-name">{{ $t('friend.newFriend') }}</div>
							</div>
						</div>
						<div class="divider"></div>
					</div>
				</template>
				<template v-slot="{ item }">
					<div class="scrollbar-content">
						<friend-item :id="item.id" :friend="item" :active="item.id === activeFriend.id"
							@chat="onSendMessage(item)" @card="onSendCard(item)" @delete="onDelFriend(item)"
							@click.native="onActiveItem(item)">
						</friend-item>
					</div>
				</template>
			</virtual-scroller>
			<el-scrollbar v-else class="friend-items">
				<div class="scrollbar-content">
					<!-- 顶部列表: 新的朋友、ai机器人等 -->
					<div v-if="enableForceAdd" class="batch-add" @click="onShowBatchForceImport">
						<i class="el-icon-circle-plus-outline"></i>
						<span>批量强加</span>
					</div>
					<div class="top-item" :class="showFriendReuqest ? 'active' : ''" @click="onClickNewFriend">
						<div class="top-item-avatar">
							<head-image :size="42" :url="require('@/assets/image/new_friend.png')">
								<div v-show="recvCount" class="unread-text">{{ recvCount }} </div>
							</head-image>
						</div>
						<div class="top-item-info">
							<div class="top-item-name">{{ $t('friend.newFriend') }}</div>
						</div>
					</div>
					<div class="divider"></div>
					<div v-for="(friends, i) in friendValues" :key="i">
						<div class="letter">{{ friendKeys[i] }}</div>
						<div v-for="friend in friends" :key="friend.id">
							<friend-item :id="friend.id" :friend="friend" :active="friend.id === activeFriend.id"
								@chat="onSendMessage(friend)" @card="onSendCard(friend)" @delete="onDelFriend(friend)"
								@click.native="onActiveItem(friend)">
							</friend-item>
						</div>
						<div v-if="i < friendValues.length - 1" class="divider"></div>
					</div>
				</div>
			</el-scrollbar>
		</resizable-aside>
		<el-container v-if="showFriendReuqest" class="container">
			<div class="header">{{ $t('friend.newFriend') }}
			</div>
			<friend-request class="request-box"></friend-request>
		</el-container>
		<el-container v-else-if="userInfo.id" class="container">
			<div class="header">
				<div class="nick-name">{{ userInfo.nickName }}</div>
				<span v-if="userInfo.companyName" class="company-tag">@{{ userInfo.companyName }}</span>
			</div>
			<div class="friend-info">
				<div class="info-card">
					<div class="avatar-section">
						<head-image :size="120" :name="userInfo.nickName" :url="userInfo.headImage" :radius="'50%'"
							@click.native="showFullImage()"></head-image>
					</div>
					<div class="info-section">
						<div class="name-header">
							<h2 class="friend-name">{{ activeFriend.showNickName || userInfo.nickName }}</h2>
							<div v-if="isFriend" :title="$t('common.more')" class="more-btn el-icon-more"
								@click="onClickMore">
							</div>
						</div>
						<div class="info-item-list">
							<div class="info-item">
								<span class="info-label">{{ $t('friend.usernameId') }}</span>
								<span class="info-value">
									{{ userInfo.customUid || userInfo.userName }}
									<el-tag v-if="userInfo.status == 1" type="danger" size="mini">{{
										$t('friend.cancelled') }}</el-tag>
								</span>
							</div>
							<div class="info-item">
								<span class="info-label">{{ $t('friend.nickname') }}</span>
								<span class="info-value">{{ userInfo.nickName }}</span>
							</div>
							<div class="info-item" v-if="userInfo.companyName">
								<span class="info-label">{{ $t('friend.company') }}</span>
								<span class="info-value">
									{{ userInfo.companyName }}
								</span>
							</div>
							<div v-if="isFriend" class="info-item remark-item">
								<span class="info-label">{{ $t('friend.remark') }}</span>
								<span class="info-value remark-content"
									:class="activeFriend.remarkNickName ? '' : 'light-text'">
									{{ activeFriend.showNickName || $t('friend.noRemark') }}
									<i class="icon iconfont icon-modify" @click="onEditRemark"></i>
								</span>
							</div>
							<div class="info-item">
								<span class="info-label">{{ $t('friend.sex') }}</span>
								<span class="info-value">{{ userInfo.sex == 0 ? $t('friend.male') : $t('friend.female')
								}}</span>
							</div>
							<div class="info-item">
								<span class="info-label">{{ $t('friend.signature') }}</span>
								<span class="info-value" v-if="userInfo.signature">{{ userInfo.signature }}</span>
								<span class="info-value light-text" v-else>{{ $t('friend.noSignature') }}</span>
							</div>
						</div>
						<div class="btn-group">
							<el-button v-show="isFriend" icon="el-icon-position" type="primary"
								@click="onSendMessage(activeFriend)">{{ $t('friend.sendMessage') }}</el-button>
							<el-button v-show="!isFriend" icon="el-icon-plus" type="primary"
								@click="onAddFriend(userInfo)">{{
									$t('friend.addAsFriend') }}</el-button>
							<el-button v-show="isFriend" icon="el-icon-delete" type="danger"
								@click="onDelFriend(userInfo)">{{
									$t('friend.deleteFriend') }}</el-button>
						</div>
					</div>
				</div>
			</div>
		</el-container>
		<img v-else src="@/assets/image/m-bg.png" alt="暂无好友信息" class="empty-img">
		<friend-apply ref="applyRef"></friend-apply>
		<chat-selector ref="chatSel" :title="$t('friend.sendCard')"></chat-selector>
		<right-menu ref="rightMenu" @select="onSelectMenu"></right-menu>
		<complaint ref="complaint"></complaint>
		<batch-force-import ref="batchForceImport"></batch-force-import>
	</el-container>
</template>

<script>
import FriendItem from "../components/friend/FriendItem.vue";
import FriendRequestItem from "../components/friend/FriendRequestItem.vue";
import AddFriend from "../components/friend/AddFriend.vue";
import HeadImage from "../components/common/HeadImage.vue";
import NoDataTip from '../components/common/NoDataTip.vue';
import FriendApply from '../components/friend/FriendApply.vue';
import FriendRequest from '../components/friend/FriendRequest.vue';
import ChatSelector from "../components/chat/ChatSelector.vue";
import RightMenu from "../components/common/RightMenu.vue";
import ResizableAside from "../components/common/ResizableAside.vue";
import VirtualScroller from "../components/common/VirtualScroller.vue";
import { pinyin } from 'pinyin-pro';
import Complaint from '../components/common/Complaint.vue';
import BatchForceImport from '../components/friend/BatchForceImport.vue';

export default {
	name: "friend",
	components: {
		FriendItem,
		FriendRequestItem,
		AddFriend,
		HeadImage,
		NoDataTip,
		FriendApply,
		FriendRequest,
		ChatSelector,
		RightMenu,
		ResizableAside,
		VirtualScroller,
		Complaint,
		BatchForceImport
	},
	data() {
		return {
			searchText: "",
			showAddFriend: false,
			activeFriend: {},
			userInfo: {},
			showFriendReuqest: false,
			menuItems: [{
				key: 'CHAT',
				name: this.$t('friend.sendMessage'),
			}, {
				key: 'CARD',
				name: this.$t('friend.sendCard'),
			}, {
				key: 'REMARK',
				name: this.$t('friend.modifyRemark'),
			}, {
				key: 'COMPLAINT',
				name: this.$t('complaint.report')
			}, {
				key: 'DELETE',
				name: this.$t('friend.deleteFriend'),
				danger: true
			}]
		}
	},
	mounted() {
		let userId = this.$route.query.id;
		if (userId) {
			let friend = this.friendStore.findFriend(parseInt(userId));
			this.onActiveItem(friend);
			this.locateItem(friend.id);
		}
	},
	methods: {
		onShowAddFriend() {
			this.showAddFriend = true;
		},
		onShowBatchForceImport() {
			this.$refs.batchForceImport.open();
		},
		onCloseAddFriend() {
			this.showAddFriend = false;
		},
		onActiveItem(friend) {
			this.activeFriend = friend;
			this.showFriendReuqest = false;
			this.loadUserInfo(friend.id);
		},
		onDelFriend(friend) {
			this.$confirm(this.$t('friend.deleteFriendConfirm', { name: friend.nickName }), this.$t('friend.confirmRemove'), {
				confirmButtonText: this.$t('common.ok'),
				cancelButtonText: this.$t('common.cancel'),
				type: 'warning'
			}).then(async () => {
				await this.$http({
					url: `/friend/delete/${friend.id}`,
					method: 'delete'
				})
				this.friendStore.removeFriend(friend.id);
				// 删除会话
				const data = { chatId: friend.id }
				await this.$http({
					url: `/message/private/deleteChat`,
					method: 'delete',
					data: data
				});
				const convKey = this.$db.buildConversationKey(this.$enums.CONVERSATION_TYPE.PRIVATE, friend.id)
				await this.chatStore.remove(convKey);
				this.$message.success(this.$t('friend.deleteFriendSuccess'));

			})
		},
		onAddFriend() {
			this.$refs.applyRef.open(this.userInfo)
		},
		async onSendMessage(friend) {
			const convKey = this.$db.buildConversationKey(this.$enums.CONVERSATION_TYPE.PRIVATE, friend.id)
			const chatInfo = {
				key: convKey,
				type: this.$enums.CONVERSATION_TYPE.PRIVATE,
				targetId: friend.id,
				showName: friend.showNickName,
				headImage: friend.headImage,
				companyName: friend.companyName,
				isDnd: friend.isDnd,
				isTop: friend.isTop
			};
			await this.chatStore.openChat(chatInfo);
			await this.chatStore.moveTop(convKey);
			this.chatStore.setActive(convKey);
			this.$router.push("/home/chat");
		},
		onSendCard(friend) {
			this.$refs.chatSel.open(conversatons => {
				let idx = 0;
				conversatons.forEach(conv => {
					const cardData = {
						userId: friend.id,
						userName: this.userInfo.customUid || this.userInfo.userName,
						nickName: friend.nickName,
						headImage: friend.headImage,
					}
					const message = {};
					message.type = this.$enums.MESSAGE_TYPE.USER_CARD;
					message.content = JSON.stringify(cardData);
					if (conv.type == this.$enums.CONVERSATION_TYPE.PRIVATE) {
						message.recvId = conv.targetId;
					} else {
						message.groupId = conv.targetId;
					}
					const chatTypeText = conv.type == this.$enums.CONVERSATION_TYPE.PRIVATE ? 'private' : 'group'
					const action = `/message/${chatTypeText}/send`;
					this.$http({
						url: action,
						method: 'post',
						data: message
					}).then(m => {
						m.selfSend = true;
						this.chatStore.openChat(conv);
						this.chatStore.insertMessage(conv.key, m);
						if (++idx == conversatons.length) {
							this.$message.success(this.$t('friend.sendSuccess'))
						}
					})
				})
			})
		},
		onEditRemark() {
			this.$prompt(this.$t('friend.inputFriendRemark'), this.$t('friend.modifyRemark'), {
				inputValue: this.activeFriend.showNickName,
				confirmButtonText: this.$t('common.ok'),
				cancelButtonText: this.$t('common.cancel'),
				inputValidator: (value) => {
					if (value && value.length > 32) {
						return this.$t('friend.remarkMax32');
					}
				}
			}).then((o) => {
				const data = {
					friendId: this.activeFriend.id,
					remarkNickName: o.value
				}
				this.$http({
					url: '/friend/update/remark',
					method: 'put',
					data: data
				}).then((friend) => {
					this.activeFriend = friend;
					this.chatStore.updateFromFriend(friend);
					this.friendStore.updateFriend(friend);
				})
			})
		},
		onComplaint(friend) {
			this.$refs.complaint.open(1, friend.id, friend.nickName)
		},
		onClickNewFriend() {
			this.activeFriend = {};
			this.showFriendReuqest = true;
		},
		onClickMore(e) {
			this.$refs.rightMenu.open(e, this.menuItems);
		},
		onSelectMenu(item) {
			switch (item.key) {
				case 'CHAT':
					this.onSendMessage(this.activeFriend);
					break;
				case 'CARD':
					this.onSendCard(this.activeFriend);
					break;
				case 'REMARK':
					this.onEditRemark();
					break;
				case 'COMPLAINT':
					this.onComplaint(this.activeFriend);
					break;
				case 'DELETE':
					this.onDelFriend(this.activeFriend);
					break;
			}
		},
		locateItem(id) {
			if (this.isFriend) {
				document.getElementById(id).scrollIntoView({ behavior: 'smooth' });
			}
		},
		showFullImage() {
			if (this.userInfo.headImage) {
				this.$eventBus.$emit("openFullImage", this.userInfo.headImage);
			}
		},
		updateFriendInfo() {
			if (this.isFriend) {
				// store的数据不能直接修改，深拷贝一份store的数据
				const friend = JSON.parse(JSON.stringify(this.activeFriend));
				friend.headImage = this.userInfo.headImageThumb;
				friend.nickName = this.userInfo.nickName;
				friend.showNickName = friend.remarkNickName ? friend.remarkNickName : friend.nickName;
				this.chatStore.updateFromFriend(friend);
				this.friendStore.updateFriend(friend);
			}
		},
		loadUserInfo(id) {
			// 获取好友用户信息
			this.$http({
				url: `/user/find/${id}`,
				method: 'GET'
			}).then((userInfo) => {
				this.userInfo = userInfo;
				this.updateFriendInfo();
			})
		},
		firstLetter(strText) {
			// 使用pinyin-pro库将中文转换为拼音
			let pinyinOptions = {
				toneType: 'none', // 无声调
				type: 'normal' // 普通拼音
			};
			let pyText = pinyin(strText, pinyinOptions);
			return pyText[0];
		},
		isEnglish(character) {
			return /^[A-Za-z]+$/.test(character);
		}
	},
	computed: {
		mine() {
			return this.userStore.userInfo;
		},
		enableForceAdd() {
			return this.mine.enableForceAdd;
		},
		friendMap() {
			// 按首字母分组
			let map = new Map();
			this.friends.forEach((f) => {
				if (this.searchText && !f.showNickName.includes(this.searchText)) {
					return;
				}
				let letter = this.firstLetter(f.showNickName).toUpperCase();
				// 非英文一律为#组
				if (!this.isEnglish(letter)) {
					letter = "#"
				}
				if (f.online) {
					letter = this.$t('friend.online')
				}
				if (map.has(letter)) {
					map.get(letter).push(f);
				} else {
					map.set(letter, [f]);
				}
			})
			// 排序：在线优先，其次字母 A-Z，# 组最后
			const onlineKey = this.$t('friend.online');
			let arrayObj = Array.from(map);
			arrayObj.sort((a, b) => {
				if (a[0] === onlineKey) return -1;
				if (b[0] === onlineKey) return 1;
				if (a[0] == '#') return 1;
				if (b[0] == '#') return -1;
				return a[0].localeCompare(b[0]);
			});
			map = new Map(arrayObj.map(i => [i[0], i[1]]));
			return map;
		},
		friendKeys() {
			return Array.from(this.friendMap.keys());
		},
		friendValues() {
			return Array.from(this.friendMap.values());
		},
		friendItems() {
			return this.friendValues.flat();
		},
		friends() {
			return this.friendStore.friends.filter(f => !f.deleted);
		},
		useVirtual() {
			return this.friends.length > 1000;
		},
		virtualFriendListKey() {
			return `${this.searchText}_${this.friendItems.length}`;
		},
		recvCount() {
			let requests = this.friendStore.requests;
			return requests.filter((req) => req.recvId == this.mine.id).length;
		},
		isFriend() {
			return this.friendStore.isFriend(this.userInfo.id);
		}
	}
}
</script>

<style lang="scss">
.friend-page {

	.divider {
		border-bottom: 1px solid rgba(216, 223, 235, 0.25);
		margin: 10px 0;
	}
	.header {
		height: 60px;
		display: flex;
		align-items: center;
		padding: 0 12px;

		.add-btn {
			padding: 6px;
			margin-left: 10px;
			font-size: 16px;
			border-radius: 50%;
			background: var(--im-background-active);
			color: var(--im-color-primary);
			transition: all 0.3s ease;
			font-weight: 600;
			border: var(--im-border);

			&:hover {
				background: var(--im-background-active-dark);
				transform: scale(1.1);
			}
		}
	}

	.batch-add {
		margin-bottom: 12px;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 8px;
		border: 1px solid transparent;
		border-radius: 8px;
		font-size: 16px;
		font-weight: bold;
		color: var(--im-text-color-primary);
		cursor: pointer;
		background: #FAFBFC;
		height: 48px;
		.el-icon-circle-plus-outline {
			font-size: 18px;
			font-weight: bold;
		}
		&:hover {
			border-color: var(--im-color-primary);
			color: var(--im-color-primary);
		}
	}

	.friend-items {
		flex: 1;
		.top-item {
			height: 50px;
			display: flex;
			position: relative;
			padding: 5px 0;
			align-items: center;
			white-space: nowrap;
			cursor: pointer;
			border-radius: 8px;
			margin-bottom: 12px;
			&:hover {
				background: linear-gradient(to right, #fff, var(--im-background-active));
			}
			&.active {
				background: linear-gradient(to right, #fff, var(--im-background-active-dark));
			}

			.top-item-avatar {
				display: flex;
				justify-content: center;
				align-items: center;

				.unread-text {
					position: absolute;
					background-color: var(--im-color-danger);
					right: -4px;
					top: -8px;
					color: white;
					border-radius: 30px;
					padding: 1px 5px;
					font-size: 10px;
					text-align: center;
					white-space: nowrap;
					border: 1px solid #f1e5e5;
				}
			}

			.top-item-info {
				flex: 1;
				display: flex;
				flex-direction: column;
				padding-left: 10px;
				text-align: left;

				.top-item-name {
					font-size: var(--im-font-size);
					white-space: nowrap;
					overflow: hidden;
				}
			}
		}
		.friend-item {
			margin: 0;
			padding: 5px 0;
			&:hover {
				background: linear-gradient(to right, #fff, var(--im-background-active));
			}
			&.active {
				background: linear-gradient(to right, #fff, var(--im-background-active-dark));
			}
		}
	}

	.letter {
		text-align: left;
		font-size: var(--im-font-size-smaller);
		padding: 5px 0;
		color: var(--im-text-color-lighter);
	}

	.empty-img {
		margin: auto;
		width: 240px;
		height: 240px;
	}
}

.container {
	display: flex;
	flex-direction: column;
	background: #fff;

	.header {
		height: 60px;
		line-height: 60px;
		display: flex;
		align-items: center;
		padding: 0 12px;
		box-sizing: border-box;
		border-bottom: var(--im-border);
		.nick-name {
			font-size: var(--im-font-size-larger);
		}
	}

	.request-box {
		flex: 1;
	}

	.friend-info {
		flex: 1;
		display: flex;
		justify-content: center;
		padding: 20px;
		align-items: center;

		.info-card {
			border-radius: 20px;
			padding: 10px;
			position: relative;
			overflow: hidden;
			max-width: 600px;
			width: 100%;
			border-radius: 20px;

			.avatar-section {
				text-align: center;
				margin-bottom: 20px;

				:deep(.head-image) {
					border: 4px solid rgba(255, 255, 255, 0.8);
					box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
					transition: all 0.3s ease;
					cursor: pointer;

					&:hover {
						transform: scale(1.05);
						box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);
						border-color: var(--im-color-primary-light-3);
					}
				}
			}

			.info-section {
				.name-header {
					display: flex;
					justify-content: space-between;
					align-items: center;
					margin-bottom: 25px;
					padding-bottom: 15px;
					border-bottom: 1px solid rgba(0, 0, 0, 0.06);

					.friend-name {
						font-size: 24px;
						font-weight: 600;
						color: var(--im-text-color-primary);
						margin: 0;
						position: relative;

						&::after {
							content: '';
							position: absolute;
							bottom: -15px;
							left: 0;
							width: 40px;
							height: 2px;
							background: var(--im-color-primary);
							border-radius: 1px;
						}
					}

					.more-btn {
						font-size: 20px;
						cursor: pointer;
						padding: 8px;
						border-radius: 50%;
						transition: all 0.3s ease;
						background: var(--im-background-active);
						color: var(--im-color-primary);

						&:hover {
							background: var(--im-background-active-dark);
							transform: scale(1.1);
						}
					}
				}

				.info-item-list {
					margin-bottom: 30px;

					.info-item {
						display: flex;
						align-items: center;
						padding: 12px 0;
						border-bottom: 1px solid rgba(0, 0, 0, 0.04);

						&:last-child {
							border-bottom: none;
						}

						.info-label {
							font-weight: 500;
							color: var(--im-text-color-secondary);
							font-size: 14px;
							min-width: 80px;
							margin-right: 20px;
						}

						.info-value {
							flex: 1;
							color: var(--im-text-color-primary);
							font-size: 15px;
							line-height: 24px;
							display: flex;
							align-items: center;
							text-align: left;
							gap: 8px;

							&.remark-content {
								display: flex;
								align-items: center;
								justify-content: space-between;

								.icon-modify {
									cursor: pointer;
									color: var(--im-color-primary);
									padding: 4px;
									border-radius: 4px;
									transition: all 0.3s ease;

									&:hover {
										background: var(--im-color-primary-light-9);
										transform: scale(1.1);
									}
								}
							}

							&.light-text {
								color: var(--im-text-color-light) !important;
							}
						}

						&.remark-item {
							.info-value {
								color: var(--im-text-color-secondary);
								font-style: italic;
							}
						}
					}
				}

				.btn-group {
					display: flex;
					gap: 12px;
					justify-content: center;
					flex-wrap: wrap;
				}
			}
		}
	}
}
.scrollbar-content {
	padding: 0 12px
}
</style>